import React, {Component} from "react";
import {Input} from 'antd';
import _ from "i18n";

export default class EnterTag extends Component {
  render() {
    return <div className={"flex items-center"}
                style={{"padding": "1.5rem", "height": "100%"}}>
      <div className={"user-card-container w-full"}>
        <div className={"m-3 text-center"}>{_('ENTER_TAG')}</div>
        <div className={"flex justify-center mb-3"}>
          <Input
            value={this.props.value}
            onChange={this.props.onChange}
            className={"feed-mango-input"}
            style={{"width": "450px"}}
          />
        </div>
      </div>
    </div>;
  }
}




// WEBPACK FOOTER //
// ./app/components/Admin/FeedMangoWallet/EnterTag.js